import { Chip, Collapse, IconButton, Tooltip, Typography } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Link from '@mui/material/Link'
import { FC, useState } from 'react'
import CopyToClipboard from 'react-copy-to-clipboard'
import LinkAltIcon from '../../../../assets/icons/LinkAlt.svg?react'
import { Notistack } from '../../../../components/Notistack'
import { ReplyCitationDTO } from '../../../../swagger/dto'
import CopyIcon from './../../../../assets/icons/Copy.svg?react'

interface Props {
    citation: ReplyCitationDTO
    index: number
}

const Citation: FC<Props> = ({ citation: { title, snippet, link }, index }) => {
    const [error, setError] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState(false)

    const handleCloseSnackbar = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }

        setOpenSnackbar(false)
    }

    let parsedLink = link

    if (!link.startsWith('https://') && !link.startsWith('http://')) {
        parsedLink = 'https://' + link
    }
    const url = new URL(parsedLink)

    const imageUrl = `${url.protocol}//${url.hostname}/favicon.ico`

    return (
        <>
            <Grid
                sx={{
                    borderRadius: '16px',
                    padding: '8px',
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    '& + &': {
                        borderTop: '1px solid #F4F4F6',
                    },
                    ':hover': {
                        backgroundColor: '#F9FAFB',
                    },
                }}>
                <Grid
                    sx={{
                        display: 'flex',
                        gap: '4px',
                        marginBottom: '8px',
                        alignItems: 'center',
                    }}>
                    {error ? (
                        <LinkAltIcon />
                    ) : (
                        <img
                            loading="lazy"
                            width={16}
                            height={16}
                            src={imageUrl}
                            onError={() => setError(true)}
                        />
                    )}
                    <Typography
                        sx={{
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: 'vertical',
                            wordBreak: 'break-all',
                            maxWidth: '200px',
                        }}
                        color="#5A5F72"
                        variant="body2">
                        {url.hostname}
                    </Typography>
                    <Chip
                        size="small"
                        sx={{
                            '& .MuiChip-label': {
                                marginRight: '0',
                            },
                            marginLeft: 'auto',
                        }}
                        label={index + 1}
                    />
                    <IconButton
                        onClick={(evt) => evt.stopPropagation()}
                        onTouchEnd={(evt) => evt.stopPropagation()}
                        onTouchStart={(evt) => evt.stopPropagation()}
                        size="small"
                        sx={{
                            backgroundColor: '#F9FAFB',
                            padding: '4px',
                        }}
                        edge="end">
                        <CopyToClipboard onCopy={() => setOpenSnackbar(true)} text={parsedLink}>
                            <Tooltip title="Скопировать ссылку на источник">
                                <CopyIcon />
                            </Tooltip>
                        </CopyToClipboard>
                    </IconButton>
                </Grid>
                <Typography marginBottom="4px" variant="h6">
                    {title}
                </Typography>
                <Collapse
                    in={true}
                    collapsedSize="40px"
                    sx={{
                        width: '100%',
                        '& .MuiCollapse-wrapperInner': {
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            display: '-webkit-box',
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: 'vertical',
                        },
                        marginBottom: '4px',
                    }}>
                    <Typography color="#5A5F72" variant="body2">
                        {snippet}
                    </Typography>
                </Collapse>
                <Link
                    target="_blank"
                    href={parsedLink}
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',
                        wordBreak: 'break-all',
                        color: '#004B9F',
                    }}
                    variant="caption2">
                    {parsedLink}
                </Link>
            </Grid>
            <Notistack
                open={openSnackbar}
                isError={false}
                message="Источник скопирован"
                onClose={handleCloseSnackbar}
            />
        </>
    )
}

export default Citation
